import { DefaultValue, atom, atomFamily, selector } from "recoil";

import type { ProcessFileType } from "@quickpoint.me/shared";

export const HostId = atom<string>({
    key: "FU__HostId",
    default: "",
});

export const OwnerName = atom<string>({
    key: "FU__OwnerName",
    default: "",
});

export const StackId = atom<string>({
    key: "FU__StackId",
    default: "",
});

export const UploadFileIds = atom<string[]>({
    key: "FU_UploadFileIds",
    default: [],
});

export const ProcessFileFamily = atomFamily<ProcessFileType | null, string>({
    key: "FU_File",
    default: null,
});

/** selectors **/
export const UnprocessedIds = selector({
    key: "FU_UnprocessedIds",
    get: ({ get }) => {
        const ids = get(UploadFileIds);
        const unprocessedIds = ids.filter(id => {
            const file = get(ProcessFileFamily(id));
            return !file?.uploadComplete;
        });

        return unprocessedIds;
    },
});

export const UnprocessedFilesPresent = selector({
    key: "FU_UnprocessedFilesPresent",
    get: ({ get }) => {
        const ids = get(UnprocessedIds);
        return ids.length > 0;
    },
});

export const CloudFlareUploadUrl = atom<{ url: string; createdAt: number }>({
    key: "FU_CloudFlareUploadUrl",
    default: { url: "init", createdAt: 0 },
});

export const CloudFlareUploadUrlSelector = selector<string | false>({
    key: "FU_CloudFlareUploadUrlSelector",
    get: ({ get }) => {
        const { url, createdAt } = get(CloudFlareUploadUrl);
        const expireTime = 29 * 60 * 1000; // 29 minutes
        const now = Date.now();
        if ((now - expireTime) > createdAt) {
            console.log("CloudFlareUploadUrl expired");
            return false;
        }
        return url;
    },

    set: ({ set }, url) => {
        // in case of reset
        if (url instanceof DefaultValue) {
            set(CloudFlareUploadUrl, { url: "init", createdAt: 0 });
            return;
        }

        if (url) {
            set(CloudFlareUploadUrl, { url, createdAt: Date.now() });
        }
    },
});
